import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthApiResponse, LoginRequest } from '../../shared/models/auth.models';

@Injectable({
    providedIn: 'root'
})
export class AuthApiService {
    private http = inject(HttpClient);
    private apiUrl = environment.apiUrl;

    private handleError = (error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred';

        if (error.error instanceof ErrorEvent) {
            // Client-side or network error
            errorMessage = error.error.message;
        } else {
            // Backend error
            errorMessage = error.error?.message || error.error?.error || error.message || 'Server error';
        }

        console.error(`AuthApiService Error:`, error);

        // Throw a standardized error object to maintain compatibility with component expectations
        return throwError(() => ({
            error: { message: errorMessage },
            status: error.status,
            originalError: error
        }));
    };

    login(credentials: LoginRequest): Observable<AuthApiResponse> {
        return this.http.post<AuthApiResponse>(`${this.apiUrl}/login`, credentials)
            .pipe(catchError(this.handleError));
    }

    logout(): Observable<any> {
        return this.http.post(`${this.apiUrl}/logout`, {})
            .pipe(catchError(this.handleError));
    }

    forgetPassword(email: string): Observable<any> {
        return this.http.post(`${this.apiUrl}/forgot-password`, { email })
            .pipe(catchError(this.handleError));
    }

    resetPassword(data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/reset-password`, data)
            .pipe(catchError(this.handleError));
    }

    getUserDetails(): Observable<any> {
        return this.http.get(`${this.apiUrl}/user`)
            .pipe(catchError(this.handleError));
    }

    firstTimeChangePassword(password: string, password_confirmation: string): Observable<any> {
        return this.http.post(`${this.apiUrl}/admin/first-time-change-password`, { password, password_confirmation })
            .pipe(catchError(this.handleError));
    }
}
